import { StepData } from '../../@types/step-data';
import { RedirectActionData } from '../../@types/action';
import Action, { ActionProps } from '../action';
import { omitBy } from '@s-libs/micro-dash';
const isEmpty = (v) => v === undefined || v === null || v === '';

const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

/** Builds a URL with the given query string params */
function buildUrl(url: string, params: Record<string, string>) {
  if (Object.keys(omitBy(params, isEmpty)).length == 0) {
    return url;
  }

  return `${url}?${Object.entries(omitBy(params, isEmpty))
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&')}`;
}

interface RedirectActionProps extends ActionProps {
  step: RedirectActionData;
}

class RedirectAction extends Action {
  step: RedirectActionData;

  constructor(props: RedirectActionProps) {
    super(props);
    this.step = props.step;
  }

  async perform(): Promise<StepData | null> {
    if (!this.conditionsSatisfied()) return this.getNextStep();
    window.location.href = this.href;
  }

  get href() {
    const { correlationId, phone_number, interview_url } = this.formData;
    switch (this.step.url) {
      case 'custom':
        return this.step.href;
      case 'home':
        return '/';
      case 'thank_you':
        return buildUrl('/contacts/marketing/thank-you', {
          correlation_id: correlationId,
          phone_number,
          time_zone: getTimezone(),
        });
      case 'tutor_thank_you':
        return buildUrl('/tutor-application/thank-you', { interview_url });
      case 'tutor_thank_you_cad':
        return buildUrl('/en-ca/tutor-application/thank-you', { interview_url });
    }
  }
}

export default RedirectAction;
